import { render, staticRenderFns } from "./DataPoint.vue?vue&type=template&id=18c9de7d&scoped=true&"
import script from "./DataPoint.vue?vue&type=script&lang=ts&"
export * from "./DataPoint.vue?vue&type=script&lang=ts&"
import style0 from "./DataPoint.vue?vue&type=style&index=0&id=18c9de7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c9de7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VBtn,VChip,VChipGroup})
